export default "__VITE_ASSET__CBcVB8Fw__"